import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { Culture } from '@app/shared/models/system-language/culture.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-localization-kendo-editor',
  templateUrl: './localization-kendo-editor.component.html',
  styleUrls: ['./localization-kendo-editor.component.scss']
})
export class LocalizationKendoEditorComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  @Input() currentCulture: Culture;
  @Input() cultures: Culture[] = [];

  @Output() emitAddtoFormArray: EventEmitter<{ fc: string, cultureId?: string }> = new EventEmitter<{ fc: string, cultureId?: string }>();
  @Output() emitDeleteFromFormArray: EventEmitter<{ index: number, formControl: string }> = new EventEmitter<{ index: number, formControl: string }>();

  public fontData = [
    { text: "8", size: "8pt" },
    { text: "9", size: "9pt" },
    { text: "10", size: "10pt" },
    { text: "11", size: "11pt" },
    { text: "12", size: "12pt" },
    { text: "14", size: "14pt" },
    { text: "16", size: "16pt" },
    { text: "18", size: "18pt" },
    { text: "20", size: "20pt" },
    { text: "22", size: "22pt" },
    { text: "24", size: "24pt" },
    { text: "26", size: "26pt" },
    { text: "28", size: "28pt" },
    { text: "36", size: "36pt" },
    { text: "48", size: "48pt" },
    { text: "72", size: "72pt" },
  ];
  isLoading: boolean;
  user$: any;
  selectedCulture: string;

  get selectedCultureObj(): Culture | undefined {
    return this.cultures.find(culture => culture.id === this.selectedCulture);
  }
  
  constructor(
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.selectedCulture = this.currentCulture?.id || (this.cultures.length > 0 ? this.cultures[0].id : '');
  }

  isSpecialUrl(): boolean {
    const url = window.location.href;
    return url.includes('qa.hubbubhr.com') || url.includes('sightsavers-sandbox.hubbubhr.com') || url.includes('sightsavers.hubbubhr.com');
  }

  isEnGbCulture(culture: string | any): boolean {
    return culture === 'en-GB' || culture?.id === 'en-GB';
  }

  addNewLocalization(cultureId?: string) {
    this.emitAddtoFormArray.emit(
      { 
        fc: this.formElement.formControl, 
        cultureId: cultureId 
      }
    );
  }

  deleteLocalization(index: number) {
    this.emitDeleteFromFormArray.emit(
      {
        index: index,
        formControl: this.formElement.formControl
      }
    );
  }

  onCultureChange(cultureId: string) {
    const formArray = this.parentGroup.get(this.formElement.formControl);
    
    // Check if current localization is blank and delete it
    if (formArray && formArray.value) {
      const currentIndex = formArray.value.findIndex((item: any) => item.culture === this.selectedCulture);
      if (currentIndex !== -1) {
        const currentValue = formArray.value[currentIndex].text;
        if (!currentValue || currentValue.trim() === '') {
          this.deleteLocalization(currentIndex);
        }
      }
    }

    this.selectedCulture = cultureId;

    if (formArray && formArray.value && !formArray.value.some((item: any) => item.culture === cultureId)) {
      this.addNewLocalization(cultureId);
    }
  }
  

}
